var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.618,
    height: 17.617,
    viewBox: "0 0 17.618 17.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icona_invia",
    "data-name": "icona invia",
    d: "M3.008,20.5,19,12.5,3.008,4.5,3,10.722,14.429,12.5,3,14.278Z",
    transform: "translate(-2.499 -3.691)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.358e1608fb28424d6a31d05d10a401dc.svg";
export { ForwardRef as ReactComponent };